import { render, staticRenderFns } from "./Depth3Main.vue?vue&type=template&id=5ba6de4e&scoped=true&"
import script from "./Depth3Main.vue?vue&type=script&lang=js&"
export * from "./Depth3Main.vue?vue&type=script&lang=js&"
import style0 from "./Depth3Main.vue?vue&type=style&index=0&id=5ba6de4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba6de4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ba6de4e')) {
      api.createRecord('5ba6de4e', component.options)
    } else {
      api.reload('5ba6de4e', component.options)
    }
    module.hot.accept("./Depth3Main.vue?vue&type=template&id=5ba6de4e&scoped=true&", function () {
      api.rerender('5ba6de4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/vendors/Terms/Depth3Main.vue"
export default component.exports